import React from 'react';
import { observer } from 'mobx-react';
import { DragDropList } from '../../../../../../global/drag-drop-list/drag-drop-list';
import { ConnectionGroupConnectionsListItem } from './connection-group-connections-list-item';
import { IConnectionItemDraggable } from './types';
import { IConnectionDetailsDTO } from '../../../../../../../api/connections.dao';

export type ConnectionGroupConnectionsListProps = {
    enabledConnections: IConnectionDetailsDTO[];
    disabledConnections: IConnectionDetailsDTO[];
    enableConnection: (index: number) => void;
    disableConnection: (index: number) => void;
    onReorder: (connections: IConnectionDetailsDTO[]) => void;
    maxEnabledConnections: number;
};

export const ConnectionGroupConnectionsList = observer((props: ConnectionGroupConnectionsListProps) => {
    const { disabledConnections, enabledConnections, enableConnection, disableConnection, onReorder, maxEnabledConnections } = props;

    const mapConnectionsToDraggableItems = (data: IConnectionDetailsDTO[]): IConnectionItemDraggable[] => {
        return data.map(connection => ({ id: connection.meetingConnectionId, ...connection }));
    };

    const mapDraggableItemsToConnections = (data: IConnectionItemDraggable[]): IConnectionDetailsDTO[] => {
        return data.map(connection => {
            delete connection.id;
            return connection;
        });
    };

    const handleReorder = (data: IConnectionItemDraggable[]): void => {
        onReorder(mapDraggableItemsToConnections(data));
    };

    const toggleInactive = enabledConnections.length >= maxEnabledConnections;

    return (
        <div className='connection-group-form__connections-list'>
            <DragDropList
                numbered={true}
                data={mapConnectionsToDraggableItems(enabledConnections)}
                renderItem={(item, index) => (
                    <ConnectionGroupConnectionsListItem
                        index={index}
                        enabled={true}
                        item={item}
                        toggle={disableConnection}
                    />
                )}
                onDragEnd={handleReorder}
            />
            <div className='connection-group-form__connections-list--disabled'>
                {mapConnectionsToDraggableItems(disabledConnections).map((item, idx) => (
                    <ConnectionGroupConnectionsListItem
                        key={idx}
                        index={idx}
                        enabled={false}
                        item={item}
                        toggle={enableConnection}
                        inactive={toggleInactive}
                    />
                ))}
            </div>
        </div>
    );
});
